import styled from 'styled-components';

const size = '60px';

export default styled.img`
  float: left;
  width: ${size};
  height: ${size};
  grid-area: image;
  align-self: center;
`;
